import { Component, OnInit, Input, Inject, ViewChild, EventEmitter, Output} from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { AdminService } from '../admin.service';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { object } from '@amcharts/amcharts5';

@Component({
  selector: 'app-admin-kyc-verification',
  templateUrl: './admin-kyc-verification.component.html',
  styleUrls: ['./admin-kyc-verification.component.css'],
})
export class AdminKycVerificationComponent implements OnInit {
  @Input() merchant_id: string;
  checked: boolean = false;
  businessInfo: any;
  businessDocuments: any;
  nameDocuments: any;
  addressDocuments: any;
  kycApproval: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  selectedKycIndex: number;
  selectedKycDetails: any;
  verifiedKyc: boolean = false;
  allMerchants: any;
  merchant: any;
  merchantDetails: any;
  rejectedReason: any;
  @Output() 
  approveButtonClicked:EventEmitter<string> =  new EventEmitter<string>();
  @Output() 
  rejectButtonClicked:EventEmitter<string> =  new EventEmitter<string>();
  constructor(
    private _matDialog: MatDialog,
    private adminService: AdminService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getAllMerchantsById();
    this.getBusinessDetailsById();
    this.getBusinessDocumentsById();
  }

  getBusinessDetailsById() {
    this.adminService.getBusinessInfo(this.merchant_id).subscribe((res) => {
      this.businessInfo = res.body;
    });
  }
  getBusinessDocumentsById() {
    this.adminService
      .getMerchanctBusinessDocuments(this.merchant_id)
      .subscribe((res) => {
        this.businessDocuments = res.body.data;
        this.nameDocuments = this.businessDocuments.filter(
          (obj) => obj.verification_type == 'NAME'
        );
        this.addressDocuments = this.businessDocuments.filter(
          (obj) => obj.verification_type == 'ADDRESS'
        );
      });
  }

  changeAgreeButton() {
    this.checked = !this.checked;
  }

  openRejectpopup() {
    const dialogRef = this._matDialog.open(BusinessRejectDialog, {
      data: { merchantId: this.merchant_id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data?.status) {
        this.getAllMerchantsById();
        this.rejectButtonClicked.emit("button click")
      }
      if (result.data?.rejectedReason) {
        this.rejectedReason = result.data?.rejectedReason;
      }
    });
  }

  openPreviewPopup(from) {
    if (from == 'name') {
      this._matDialog.open(PreviewDialog, {
        data: { documents: this.nameDocuments },
      });
    } else if (from == 'business') {
      this._matDialog.open(PreviewDialog, {
        data: { documents: this.addressDocuments },
      });
    }
  }

  openApprovalPopup() {
    const approvalDialogRef = this._matDialog.open(ApprovalDialog, {
       data: { merchantId: this.merchant_id },
    });
    approvalDialogRef.afterClosed().subscribe((result) => {
      if (result.data?.status) {
        this.getAllMerchantsById();
        this.approveButtonClicked.emit("button clicked")
      }
    });
  }



  getAllMerchantsById() {
    this.adminService.getAllMerchants().subscribe((res) => {
      this.allMerchants = res.body.data;
      this.merchantDetails = this.allMerchants.find(
        (object) => object.merchant_id == this.merchant_id
      );
    });
  }
}

@Component({
  selector: 'business-reject-dialog',
  templateUrl: 'business-reject-dialog.html',
  styleUrls: [
    './admin-kyc-verification.component.css',
    '../admin-template/admin-template.component.css',
  ],
})
export class BusinessRejectDialog {
  rejectedReason: any;
  merchantID: any;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    public dialogRef: MatDialogRef<BusinessRejectDialog>,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar
  ) {
    this.merchantID = this.data.merchantId;
  }

  closePopup() {
    this.dialogRef.close();
  }

  rejectTemplate() {
    let request = {
      status: 'REJECTED',
      status_reason: this.rejectedReason,
    };
    this.adminService.updateMerchant(this.merchantID, request).subscribe(
      (res) => {},
      (error) => {
        if (error.status == 200) {
          this.dialogRef.close({
            event: 'close',
            data: {
              status: 'rejected',
              rejectedReason: this.rejectedReason,
            },
          });
          // this._snackBar.open('Rejected Successfully', 'close', {
          //   duration: 3000,
          //   horizontalPosition: this.horizontalPosition,
          //   verticalPosition: this.verticalPosition,
          // });
        } else {
          this._snackBar.open(error.error.message, 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
          });
        }
      }
    );
  }

  clearInput() {
    this.rejectedReason = '';
  }
}

@Component({
  selector: 'preview-dialog',
  templateUrl: 'preview-dialog.html',
  styleUrls: [
    './admin-kyc-verification.component.css',
    '../admin-template/admin-template.component.css',
  ],
})
export class PreviewDialog {
  previewDocuments: any;
  constructor(
    public dialogRef: MatDialogRef<PreviewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.previewDocuments = this.data.documents;
  }

  closePopup() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'approval-dialog',
  templateUrl: 'approval-dialog.html',
  styleUrls: [
    './admin-kyc-verification.component.css',
    '../admin-template/admin-template.component.css',
  ],
})
export class ApprovalDialog {
  merchant_id: any;
  horizontalPosition: MatSnackBarHorizontalPosition='end';
  verticalPosition: MatSnackBarVerticalPosition='top';

  constructor(public dialogRef: MatDialogRef<ApprovalDialog>, private adminService: AdminService, private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.merchant_id = this.data.merchantId;
  }

  closePopup() {
    this.dialogRef.close();
  }

  verifyKyc(action) {
    let request = {
      status: action,
      status_reason: 'Too generic.',
    };

    this.adminService.updateMerchant(this.merchant_id, request).subscribe(
      (res) => {},
      (error) => {
        if (error.status == 200) {
          this.dialogRef.close({ event: 'close',
          data: {
            status: 'approved'
          }});
          // this._snackBar.open('Verified Successfully', 'close', {
          //   duration: 3000,
          //   horizontalPosition: this.horizontalPosition,
          //   verticalPosition: this.verticalPosition,
          // });
        }
      }
    );
  }
}
